import React from "react";
import { usePermission, PermissionAction } from "../hooks/usePermission";
import { Tooltip } from "@mui/material";

interface CanProps {
    module: string;
    action?: PermissionAction;
    children: React.ReactElement; // Change to ReactElement for cloning
    fallback?: React.ReactNode;
    isDisabledMode?: boolean;
}

const Can: React.FC<CanProps> = ({ module, action = "isView", children, fallback = null, isDisabledMode = false }) => {
    const { hasPermission, isLoading } = usePermission();

    if (isLoading) return null;

    const allowed = hasPermission(module, action);

    if (allowed) {
        return children;
    }

    if (isDisabledMode) {
        return (
            <Tooltip title="You don't have permission to perform this action" arrow>
                <span>
                    {React.cloneElement(children, {
                        disabled: true,
                        style: { ...children.props.style, pointerEvents: "none" }
                    })}
                </span>
            </Tooltip>
        );
    }

    return <>{fallback}</>;
};

export default Can;
